<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title>Inventory</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" md="4">
            <v-text-field
              name="inventorySearch"
              outlined
              dense
              label="Search"
              v-model="search"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-autocomplete
              autocomplete="off"
              hide-details
              dense
              outlined
              v-model="queryCategory"
              :items="categories"
              label="Category"
              item-text="Name"
              item-value="id"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" md="8">
            <v-btn text color="accent" @click="getStock" :loading="loader"
              ><v-icon left color="black">mdi-printer</v-icon>Print All
              Products</v-btn
            >
            <v-btn
              class="ml-3"
              text
              color="accent"
              @click="getAvailableStock"
              :loading="loader"
              ><v-icon left color="black">mdi-printer</v-icon>Print
              Available</v-btn
            >

            <download-excel
              :data="inventory"
              :fields="fields"
              :name="`Current Stock ${storeName}`"
            >
              <v-icon color="green">mdi-file-excel</v-icon>
            </download-excel>
            <!-- start of table -->
            <v-data-table
              :items-per-page="2000"
              loading-text="Loading Data......"
              :headers="headers"
              :items="inventory"
              :search="search"
              :mobile-breakpoint="0"
            >
              <template v-slot:item.product.Name="{ item }">
                <v-btn
                  v-if="item.product"
                  color="primary"
                  text
                  :to="`/quick-audit/${item.product.id}`"
                  >{{ item.product.Name }}</v-btn
                >
              </template>

              <template v-slot:item.BuyingPrice="{ item }">{{
                item.BuyingPrice.toLocaleString()
              }}</template>

              <template v-slot:item.SellingPrice="{ item }">{{
                item.SellingPrice.toLocaleString()
              }}</template>

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" @click="openModal(item)" text icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <!-- damaged template -->
              <template v-slot:item.damage="{ item }">
                <v-btn color="red" @click="openDamageModal(item)" small text>
                  <v-icon left>mdi-minus</v-icon>Record Damage
                </v-btn>
              </template>
              <!-- end -->

              <!-- damaged template -->
              <template v-slot:item.transfer="{ item }">
                <v-btn
                  color="primary"
                  @click="openTransferModal(item)"
                  small
                  text
                >
                  <v-icon left>mdi-alpha-t-circle-outline</v-icon>Transfer Stock
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <!-- Inventory Edit dialog -->
        <v-dialog v-model="dialog" max-width="700px">
          <v-card>
            <v-toolbar dense color="primary" dark>
              <v-toolbar-title>Edit Inventory Data</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row class="displayText">
                  <v-col cols="12" xs="12" md="4" v-if="editItem.product">
                    <span>{{ editItem.product.Name }}</span>
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-text-field
                      name="inventoryAvailableQty"
                      v-model="editItem.AvailableQty"
                      label="Available Qty"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-text-field
                      name="inventoryBuyingPrice"
                      v-model="editItem.BuyingPrice"
                      label="Buying Price"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-text-field
                      name="inventoryAverageBuyingPrice"
                      v-model="editItem.AvgBuyingPrice"
                      label="Average Buying Price"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <!-- <v-col cols="4">
                    <span v-if="editItem.BuyingPrice">Buying Price: {{editItem.BuyingPrice.toLocaleString()}}</span>
                  </v-col>

                  <v-col cols="4">
                    <span v-if="editItem.AvgBuyingPrice">Avg Buying Price: {{editItem.AvgBuyingPrice.toLocaleString()}}</span>
                  </v-col>-->

                  <!-- <v-col cols="4">
                    <v-text-field v-model="editItem.Reorder" label="Reorder Value" outlined dense></v-text-field>
                  </v-col>-->

                  <v-col cols="12">
                    <v-btn
                      color="accent"
                      @click="save"
                      :loading="$store.state.btnLoader"
                    >
                      <v-icon left>mdi-content-save</v-icon>Save
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of edit dialog -->

        <!-- Damaged Product dialog -->
        <v-dialog v-model="damageDialog" max-width="700px">
          <v-card>
            <v-toolbar dense color="red" dark>
              <v-toolbar-title>Record Damaged Product</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="damageDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" v-if="damagedItem.product">
                    <v-text-field
                      name="damageProductName"
                      v-model="damagedItem.product.Name"
                      label="Product"
                      filled
                      readonly
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6">
                    <v-text-field
                      name="damageQuantity"
                      v-model="damagedItem.Quantity"
                      label="Quantity"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6">
                    <DatePicker
                      @date="setDate"
                      :myDate="date"
                      :title="`Date`"
                    ></DatePicker>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      name="damageRemarks"
                      v-model="damagedItem.Remarks"
                      label="Remarks"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="accent" @click="saveDamage" :loading="loader">
                      <v-icon left>mdi-content-save</v-icon>Save
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of damage modal-->
      </v-card-text>
      <!-- snackbar -->
      <snackbar ref="snackbar"></snackbar>
    </v-card>
  </v-container>
</template>

<script>
import { http } from "@/common/index";
export default {
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
    storeName() {
      return localStorage.getItem("storeName");
    },
  },
  data() {
    return {
      search: null,
      queryCategory: null,
      categories: [],
      pageItems: 500,
      loader: false,
      editItem: {},
      damagedItem: {},
      transferItem: {},
      smsRef: null,
      store: null,
      stores: [],
      users: [],
      date: null,
      dialog: false,
      damageDialog: false,
      transferDialog: false,
      headers: [
        { text: "Item Code", value: "product.ItemCode" },
        { text: "Product Name", value: "product.Name" },
        { text: "Available Qty", value: "AvailableQty" },
        // { text: "Action", value: "action" },
      ],
      fields: {
        ItemCode: "product.ItemCode",
        Product: "product.Name",
        Quantity: "AvailableQty",
      },
      inventory: [],
    };
  },
  methods: {
    printInventory(stock) {
      return http.post("http://localhost/print/inventory", {
        stock,
      });
    },
    printNaivashaStock(data) {
      return http.post("http://localhost/print/inventory", {
        data,
      });
    },
    printLocalInventory(stock) {
      return http.post(
        "http://localhost/stalispos-receipt/src/inventory/InventoryData.php",
        {
          stock,
        }
      );
    },
    getStock() {
      this.loader = true;
      const self = this;
      this.$store
        .dispatch("get", `/stores/products/${this.activeStore}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            let details = {
              storeName: self.storeName,
              stock: res.ResponseData,
            };
            self.printInventory(res.ResponseData);
            self.printLocalInventory(details);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAvailableStock() {
      this.loader = true;
      const self = this;
      this.$store
        .dispatch("get", `/stores/available/products/${this.activeStore}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            let details = {
              storeName: self.storeName,
              stock: res.ResponseData,
            };
            self.printInventory(res.ResponseData);
            self.printLocalInventory(details);
            if (self.smsRef == "narasha") {
              self.printNaivashaStock(details);
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(date) {
      this.date = date;
    },
    openModal(item) {
      this.editItem = Object.assign({}, item);
      this.dialog = true;
    },
    openDamageModal(item) {
      this.damagedItem = Object.assign({}, item);
      this.damageDialog = true;
    },
    openTransferModal(item) {
      this.transferItem = Object.assign({}, item);
      this.transferDialog = true;
    },
    inventoryInit() {
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("get", `/available-stock`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.inventory = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    // getProducts() {
    //   const self = this;
    //   //  get store id first
    //   this.$store
    //     .dispatch("get", `/general-settings`)
    //     .then((res) => {
    //       if (res.ResultCode == 1200) {
    //         self.inventoryInit(res.ResponseData.DefaultStockStore);
    //       } else {
    //         this.$refs.snackbar.show(res.msg, "red");
    //       }
    //     })
    //     .catch((err) => {
    //       this.$refs.snackbar.show(err, "red");
    //     });
    //   // end
    // },
    saveDamage() {
      const data = this.damagedItem;
      const TotalDamagedValue = parseInt(data.Quantity) * data.AvgBuyingPrice;
      data.TotalDamagedValue = TotalDamagedValue;
      data.DocDate = this.date;
      const url = `/spoiled-products`;
      // const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            location.reload();
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    save() {
      const data = this.editItem;
      const url = `/inventory/${data.id}`;
      const self = this;
      self.$store.commit("btnLoader", true);
      this.$store
        .dispatch("put", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            location.reload();
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/products-categories`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData) {
              self.smsRef = res.ResponseData.smsRef;
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([
      this.inventoryInit(),
      this.getStores(),
      this.getUsers(),
      this.getCategories(),
      this.getGenSettings(),
    ]);
  },
};
</script>

<style lang="scss" scoped>
</style>